var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chrome_svg__clip0_20_7702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9987C15.3137 17.9987 18 15.3124 18 11.9987C18 8.685 15.3137 5.99872 12 5.99872C8.68629 5.99872 6 8.685 6 11.9987C6 15.3124 8.68629 17.9987 12 17.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80347 15L1.60814 6.00146C0.554709 7.82546 7.26776e-05 9.89468 7.14205e-09 12.001C-7.26633e-05 14.1074 0.554423 16.1767 1.60773 18.0007C2.66104 19.8248 4.17604 21.3394 6.00038 22.3923C7.82472 23.4452 9.8941 23.9991 12.0005 23.9986L17.1958 15V14.9985C16.6696 15.911 15.9123 16.6689 15.0003 17.1958C14.0882 17.7228 13.0534 18.0003 12.0001 18.0005C10.9467 18.0006 9.91185 17.7234 8.99962 17.1967C8.08743 16.67 7.32994 15.9124 6.80347 15Z",
    fill: "url(#chrome_svg__paint0_linear_20_7702)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1955 14.9997L12.0002 23.9982C14.1066 23.9985 16.1759 23.4442 18.0001 22.3911C19.8243 21.338 21.339 19.8232 22.3921 17.9989C23.4451 16.1747 23.9993 14.1053 23.999 11.999C23.9986 9.89262 23.4437 7.82352 22.39 5.99963H11.9993L11.998 6.00043C13.0514 5.9999 14.0864 6.27678 14.9988 6.80314C15.9112 7.32954 16.6689 8.08687 17.1957 8.99906C17.7225 9.91121 17.9999 10.946 17.9999 11.9994C17.9998 13.0527 17.7224 14.0875 17.1955 14.9997Z",
    fill: "url(#chrome_svg__paint1_linear_20_7702)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.75C14.6233 16.75 16.75 14.6234 16.75 12C16.75 9.37667 14.6233 7.25 12 7.25C9.37663 7.25 7.25 9.37667 7.25 12C7.25 14.6234 9.37663 16.75 12 16.75Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6H22.3905C21.3376 4.1757 19.8229 2.66075 17.9988 1.60751C16.1747 0.55427 14.1054 -0.000149467 11.999 3.02255e-08C9.89265 0.000149527 7.82347 0.554861 5.99951 1.60836C4.17551 2.66186 2.66107 4.17703 1.6084 6.00145L6.8037 15L6.80503 15.0007C6.27791 14.0887 6.00019 13.0541 5.99985 12.0007C5.99951 10.9473 6.27657 9.91242 6.80313 9.00011C7.32964 8.08781 8.08716 7.33021 8.99939 6.80358C9.91166 6.27691 10.9465 5.99977 11.9999 6Z",
    fill: "url(#chrome_svg__paint2_linear_20_7702)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__paint0_linear_20_7702",
    x1: 13.2986,
    y1: 23.2491,
    x2: 2.90752,
    y2: 5.25129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__paint1_linear_20_7702",
    x1: 10.2494,
    y1: 24.03,
    x2: 20.6404,
    y2: 6.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__paint2_linear_20_7702",
    x1: 1.6084,
    y1: 7.50034,
    x2: 22.3905,
    y2: 7.50034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__clip0_20_7702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgChrome;